import { render, staticRenderFns } from "./ExamSummaryDialog.vue?vue&type=template&id=1a89f10c&scoped=true"
import script from "./ExamSummaryDialog.vue?vue&type=script&lang=js"
export * from "./ExamSummaryDialog.vue?vue&type=script&lang=js"
import style0 from "./ExamSummaryDialog.vue?vue&type=style&index=0&id=1a89f10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89f10c",
  null
  
)

export default component.exports